import Immutable from 'immutable';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import BrowseHomePage from 'app/components/shared/browse/BrowseHomePage';
import ErrorPage from 'app/components/ErrorPage';
import { HTTP_STATUS_CODE } from 'app/constants/ErrorConstants';
import { hasPreviewPermissions } from 'app/helpers/admin/browse/home';
import { mapBrowseConfigElementsToRows } from 'app/helpers/browse/rows';
import { selectCurrentUser } from 'app/selectors/AuthSelector';
import { selectBrowseHomeConfig } from 'app/selectors/browse/browseHomeSelector';
import { selectBibEntities, selectListEntities, selectUserEntities } from 'app/selectors/EntitiesSelector';

const AdminBrowseHomePreviewPageContainer = () => {
  const intl = useIntl();

  const currentUser = useSelector(selectCurrentUser);

  const browseHomePageConfig = useSelector(selectBrowseHomeConfig) ?? Immutable.Map();
  const listsById = useSelector(selectListEntities);
  const searchBibByMetadataId = useSelector(selectBibEntities);
  const usersById = useSelector(selectUserEntities);

  const canPreview = hasPreviewPermissions(currentUser);
  if (!canPreview) {
    return <ErrorPage httpStatusCode={HTTP_STATUS_CODE.FORBIDDEN} />;
  }

  const browseHomeRows = mapBrowseConfigElementsToRows(browseHomePageConfig.get('elements', Immutable.List())?.toJS(), {
    hasHistoryRoutingForBibTitles: false,
    hasHistoryRoutingForNavLinks: false,
    listById: listsById?.toJS(),
    searchBibByMetadataId: searchBibByMetadataId?.toJS(),
    userById: usersById?.toJS()
  });

  const pageTitle = intl.formatMessage({ defaultMessage: 'Browse', id: 'browse' });

  return <BrowseHomePage displayAvailabilitByMetadataId={{}} pageTitle={pageTitle} rows={browseHomeRows} />;
};

export default AdminBrowseHomePreviewPageContainer;
